import { isEmpty } from "lodash-es";
import { useIntl } from "react-intl";
import type { InfinitySelectOption } from "~components/InfinitySelect";
import { SelectStage } from "~components/SelectStage/SelectStage";
import type { Stage } from "~types/stage";
import { useUpdateListFixture } from "../../hooks";
import type { ColumnComponentProperties } from "../../types";

interface IStageColumnProperties extends ColumnComponentProperties {
  stage: Stage;
}

export const StageColumn = (properties: IStageColumnProperties) => {
  const { formatMessage } = useIntl();
  const { mutate: updateFixture, isPending: isLoading } = useUpdateListFixture();

  if (properties.editMode) {
    const value = isEmpty(properties.stage)
      ? null
      : {
          label: properties.stage.nameLocal,
          value: properties.stage.stageCode,
        };

    const onChangeHandler = (stageOption: InfinitySelectOption | null) =>
      updateFixture({
        fixtureId: properties.fixtureId,
        upsertData: {
          stageCode: stageOption?.value ? stageOption?.value : null,
          seriesCode: null,
        },
      });

    return (
      <SelectStage
        disabled={isLoading}
        placeholder={formatMessage({
          id: "fixtureListPage.table.column.editMode.stage.placeholder",
        })}
        value={value}
        onChange={onChangeHandler}
      />
    );
  }

  return properties.stage?.nameLocal;
};
